import { environment } from './../../../environments/environment';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromEvent';
import { Injectable, NgZone } from '@angular/core';
import * as _ from 'lodash';

/**
 * @description
 * @class
 */
@Injectable()
export class GlobalPropertiesService {
  public windowResize$: BehaviorSubject<{ windowHeight: number, windowWidth: number }> = new BehaviorSubject(null);


  public appGlobal = {
    name: 'KalipsoRC', // name of your project
    author: 'Westport Solutions', // author's name or company name
    description: 'Amazing audio delivery', // brief description
    activationPhone: '(706) 782-9750', // activation number shown on player when deactivated
    version: environment.VERSION, // current version
    year: ((new Date()).getFullYear()), // automatic current year (for copyright information)
    isMobile: this.isMobile(),
    impersonationUser: null,
    isImpersonatingUser: false,
    windowHeight: 0,
    windowWidth: 0,
    isLargeDevice: false,
    isSmallDevice: false,
    isMobileDevice: false,
    currentPageTitle: '',
    currentPageSubTitle: '',
    isDesignerMode: false,
    oneTimePlayerKey: '',
    currentPlayerZip: '',
    defaultLayout: {
      isNavbarFixed: true, // true if you want to initialize the template with fixed header
      isLeftSidebarFixed: true, // true if you want to initialize the template with fixed sidebar
      isLeftSidebarClosed: false, // true if you want to initialize the template with closed sidebar
      isLeftSidebarMobileClosed: true, // slide out in mobile mode
      isRightSidebarClosed: true, // true if you want to initialize the template with closed sidebar
      isFooterFixed: true, // true if you want to initialize the template with fixed footer
      isBoxedPage: false, // true if you want to initialize the template with boxed layout
      layoutName: 'lyt-2',
      theme: 'lyt2-theme-1', // indicate the theme chosen for your project
      logo: 'assets/images/kanvas-logo-white-small.png', // relative path of the project logo
      logoCollapsed: 'assets/images/logo-collapsed.png' // relative path of the collapsed logo
    },
    layout: {
      isNavbarFixed: true, // true if you want to initialize the template with fixed header
      isLeftSidebarFixed: true, // true if you want to initialize the template with fixed sidebar
      isLeftSidebarClosed: false, // true if you want to initialize the template with closed sidebar
      isLeftSidebarMobileClosed: true, // slide out in mobile mode
      isRightSidebarClosed: true, // true if you want to initialize the template with closed sidebar
      isFooterFixed: true, // true if you want to initialize the template with fixed footer
      isBoxedPage: false, // true if you want to initialize the template with boxed layout
      layoutName: 'lyt-2',
      theme: 'lyt2-theme-1', // indicate the theme chosen for your project
      logo: 'assets/images/logo.png', // relative path of the project logo
      logoCollapsed: 'assets/images/kanvas-logo-white-small.png' // relative path of the collapsed logo
    }
  };


  constructor(
    public ngZone: NgZone,

  ) {
    this.appGlobal.layout = _.cloneDeep(this.appGlobal.defaultLayout);
    this.UpdateSizeProps(); // get initial size
    this.StartWatchingResize();
  }

  isMobile() {
    // true if the browser is a mobile device
    let check = false;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      check = true;
    }
    return check;
  }

  StartWatchingResize() {
    // debounce resize, wait for resize to finish before doing stuff
    const resizeObservable = Observable.fromEvent(window, 'resize');
    const resizeRateLimited = resizeObservable;

    // resizeObservable.(() => Observable.interval(15));

    resizeRateLimited.subscribe((event) => {
      // wait 50ms before sending event to let things settle
      this.UpdateSizeProps();
    });
  }


  UpdateSizeProps() {
    this.appGlobal.windowHeight = this.viewport().height;
    this.appGlobal.windowWidth = this.viewport().width;

    if (this.appGlobal.windowWidth >= 992) {
      this.appGlobal.isLargeDevice = true;
    } else {
      this.appGlobal.isLargeDevice = false;
    }
    if (this.appGlobal.windowWidth < 992) {
      this.appGlobal.isSmallDevice = true;
    } else {
      this.appGlobal.isSmallDevice = false;
    }
    if (this.appGlobal.windowWidth < 768) {
      this.appGlobal.isMobileDevice = true;
    } else {
      this.appGlobal.isMobileDevice = false;
    }

    // publish changes to subscribers
    this.windowResize$.next({ windowHeight: this.appGlobal.windowHeight, windowWidth: this.appGlobal.windowWidth });

  }

  // Function that finds the exact height and width of the main viewport in a cross-browser way
  viewport() {
    let e: any = window;
    let a = 'inner';
    if (!('innerWidth' in window)) {
      a = 'client';
      e = document.documentElement || document.body;
    }
    return {
      width: e[a + 'Width'],
      height: e[a + 'Height']
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/core.module/services/global-properties.service.ts